export const validateAccount = 'validate-account';

export const registrationStatus = 'registration-status';

export const creation = {
  container: 'register',
  info: 'info',
  files: 'files',
  drivingLicense: 'drivingLicense',
  identityDocument: 'identityDocument',
  selfie: 'selfie',
  moreInfo: 'moreInfo',
  id: 'companyId'
};

export const book = 'book';
